export default [
    {
        path: 'dailyEfmBridgeMaintenanceFile',
        name: 'dailyEfmBridgeMaintenanceFile',
        meta: {
            title: '桥梁维修档案',
            auth: true
        },
        component: () =>
            import('@/views/conserve/maintenanceDossier/efmBridgeMaintenanceFile')
    },
    {
        path: 'dailyEfmFacilityMaintenanceFile',
        name: 'dailyEfmFacilityMaintenanceFile',
        meta: {
            title: '设施维修档案',
            auth: true
        },
        component: () =>
            import('@/views/conserve/maintenanceDossier/efmFacilityMaintenanceFile')
    },
    {
        path: 'dailyEfmOilRepairFile',
        name: 'dailyEfmOilRepairFile',
        meta: {
            title: '路面维修档案',
            auth: true
        },
        component: () =>
            import('@/views/conserve/maintenanceDossier/efmOilRepairFile')
    },
    {
        path: 'dailyEfmRcRepairFile',
        name: 'dailyEfmRcRepairFile',
        meta: {
            title: '路面裂缝修补档案',
            auth: true
        },
        component: () =>
            import('@/views/conserve/maintenanceDossier/efmRcRepairFile')
    }
]